import { FormattedMessage, useIntl } from "react-intl";
import { ProductImportJob } from "../../../types/product-import-job";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface IStep3Props {
  job: ProductImportJob;
}

function Step3({ job }: IStep3Props) {
  const intl = useIntl();

  const navigate = useNavigate();
  const isSuccess =
    job.status === "completed" &&
    (!job.results || job.results.errorCount === 0);
  const isWarning =
    job.status === "completed" && job.results && job.results.errorCount > 0;
  const isError = job.status === "failed";

  return (
    <div className="card card-bordered card-preview">
      <div className="card-inner text-center">
        {isSuccess && (
          <>
            <em
              className="icon ni ni-check-circle-fill text-success"
              style={{ fontSize: "5rem" }}
            ></em>
            <h4 className="mt-3">
              <FormattedMessage id="Import completed successfully" />
            </h4>
            <p>
              <FormattedMessage
                id="{count} products were imported."
                values={{ count: job.results?.successCount }}
              />
            </p>
          </>
        )}
        {isWarning && (
          <>
            <em
              className="icon ni ni-alert-circle-fill text-warning"
              style={{ fontSize: "5rem" }}
            ></em>
            <h4 className="mt-3">
              <FormattedMessage id="Import completed with errors" />
            </h4>
            <p>
              <FormattedMessage
                id="{successCount} products were imported successfully, but {errorCount} failed."
                values={{
                  successCount: job.results?.successCount,
                  errorCount: job.results?.errorCount,
                }}
              />
            </p>
          </>
        )}
        {isError && (
          <>
            <em
              className="icon ni ni-cross-circle-fill text-danger"
              style={{ fontSize: "5rem" }}
            ></em>
            <h4 className="mt-3">
              <FormattedMessage id="Import failed" />
            </h4>
            <p>
              <FormattedMessage id="There was an error processing the file." />
            </p>
          </>
        )}

        {job.results && job.results.issues?.length > 0 && (
          <div className="text-left mt-5">
            <hr />
            <h5 className="mt-3">
              <FormattedMessage id="Details" />
            </h5>
            <div className="table-responsive mt-3">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>
                      <FormattedMessage id="Row" />
                    </th>
                    <th>
                      <FormattedMessage id="Level" />
                    </th>
                    <th>
                      <FormattedMessage id="Message" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {job.results.issues.map((issue, index) => (
                    <tr key={index}>
                      <td>
                        <small>{issue.row}</small>
                      </td>
                      <td>
                        <span
                          className={`badge bg-${
                            issue.level === "error"
                              ? "danger"
                              : issue.level === "warning"
                                ? "warning"
                                : "info"
                          }`}
                        >
                          {<FormattedMessage id={issue.level} />}
                        </span>
                      </td>
                      <td>
                        {intl.formatMessage({ id: issue.message }, issue.meta)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <div className="card-inner text-center">
        <Button
          onClick={() => {
            navigate(`/products`);
          }}
          className="btn btn-primary"
        >
          <em className="icon ni ni-arrow-left me-1" />
          <FormattedMessage id="Go to products" />
        </Button>
      </div>
    </div>
  );
}

export default Step3;
